"use client";
import { Scale } from "@/animations/scale";
import Image from "@/components/Image";
import { cn } from "@/utils";
import { useResize } from "@/utils/useResize";
import { cva } from "class-variance-authority";
import { Link } from "react-router-dom";
import { HeaderFinder } from "./header-finder";
import { WrapperFinder } from "./wrapper-finder";

const variants = cva("w-full", {
  variants: {
    twSize: {
      xs: "max-w-[314px] mr-[14px] mt-[32px]",
      sm: "max-w-[314px] mr-[14px] mt-[32px]",
      md: "max-w-[314px] mr-[14px] mt-[32px]",
      lg: "max-w-[314px] ml-[364px] mt-[24px]",
      xl: "max-w-[314px] ml-[340px] mt-[24px]",
      "2xl": "max-w-[314px] ml-[361px] mt-[26px]",
      "3xl": "max-w-[314px] ml-[383px] mt-[28px]",
    },
  },
  defaultVariants: {
    twSize: "2xl",
  },
});

export function FinderSocial() {
  const { twSize } = useResize();

  return (
    <Scale>
      <div className="w-full flex flex-row justify-end lg:justify-start">
        <WrapperFinder className={cn(variants({ twSize: twSize }))}>
          <HeaderFinder>
            <div className="flex gap-1 items-center justify-center flex-row">
              <Image
                src={require("@/assets/icons/ic_folder.png")}
                width={18}
                height={19}
                alt="folder"
              />
              <p className="text-[#23262F] text-center text-[13px] font-medium leading-4 truncate">
                Social
              </p>
            </div>
          </HeaderFinder>

          <div className={""}>
            <div className="flex flex-row gap-[2] items-center justify-between md:p-6 p-4">
              <Link
                to={"https://discord.com/invite/holdstation"}
                target="_blank"
                className="flex flex-col gap-2 justify-center items-center "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="49"
                  height="48"
                  viewBox="0 0 49 48"
                  fill="none"
                  className="mx-2"
                >
                  <title>Discord</title>
                  <rect x="0.5" width="48" height="48" rx="12" fill="#5562F5" />
                  <path
                    d="M36.3815 12.5594C34.1962 11.507 31.8528 10.7317 29.4027 10.2876C29.3581 10.279 29.3135 10.3004 29.2905 10.3433C28.9892 10.9059 28.6553 11.6398 28.4216 12.2167C25.7863 11.8026 23.1646 11.8026 20.5833 12.2167C20.3495 11.627 20.0036 10.9059 19.7008 10.3433C19.6778 10.3019 19.6333 10.2804 19.5886 10.2876C17.1399 10.7302 14.7965 11.5056 12.6099 12.5594C12.591 12.568 12.5748 12.5823 12.564 12.6008C8.11914 19.5705 6.9015 26.3688 7.49883 33.0829C7.50154 33.1157 7.5191 33.1471 7.54343 33.1671C10.476 35.4275 13.3167 36.7997 16.1047 37.7093C16.1493 37.7236 16.1966 37.7065 16.225 37.6679C16.8845 36.7226 17.4724 35.726 17.9764 34.6778C18.0061 34.6164 17.9777 34.5436 17.917 34.5193C16.9845 34.1481 16.0966 33.6954 15.2425 33.1814C15.1749 33.14 15.1695 33.0386 15.2317 32.99C15.4114 32.8487 15.5912 32.7016 15.7628 32.5531C15.7938 32.526 15.8371 32.5202 15.8736 32.5374C21.4847 35.2262 27.5594 35.2262 33.1042 32.5374C33.1407 32.5188 33.184 32.5245 33.2164 32.5517C33.3881 32.7002 33.5678 32.8487 33.7489 32.99C33.811 33.0386 33.807 33.14 33.7394 33.1814C32.8853 33.7054 31.9974 34.1481 31.0636 34.5179C31.0028 34.5422 30.9758 34.6164 31.0055 34.6778C31.5204 35.7245 32.1082 36.7212 32.7556 37.6665C32.7826 37.7065 32.8312 37.7236 32.8759 37.7093C35.6773 36.7997 38.518 35.4275 41.4506 33.1671C41.4763 33.1471 41.4925 33.1171 41.4952 33.0843C42.2101 25.3221 40.2978 18.5795 36.426 12.6022C36.4166 12.5823 36.4004 12.568 36.3815 12.5594ZM18.8143 28.9947C17.125 28.9947 15.7331 27.3669 15.7331 25.3678C15.7331 23.3687 17.098 21.7409 18.8143 21.7409C20.5441 21.7409 21.9226 23.383 21.8955 25.3678C21.8955 27.3669 20.5306 28.9947 18.8143 28.9947ZM30.2068 28.9947C28.5175 28.9947 27.1256 27.3669 27.1256 25.3678C27.1256 23.3687 28.4905 21.7409 30.2068 21.7409C31.9366 21.7409 33.3151 23.383 33.2881 25.3678C33.2881 27.3669 31.9366 28.9947 30.2068 28.9947Z"
                    fill="white"
                  />
                </svg>
                <p className="text-sm leading-4 font-medium text-center truncate">
                  Discord
                </p>
              </Link>
              <Link
                to={"https://twitter.com/HoldstationW"}
                target="_blank"
                className="flex flex-col gap-2 justify-center items-center"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="49"
                  height="48"
                  viewBox="0 0 49 48"
                  fill="none"
                  className="mx-2"
                >
                  <title>Twitter</title>
                  <rect x="0.5" width="48" height="48" rx="12" fill="#0F1419" />
                  <path
                    d="M26.786 22.1634L35.7215 12H33.6043L25.8421 20.8229L19.647 12H12.5L21.8704 25.343L12.5 36H14.6171L22.8092 26.6805L29.353 36H36.5L26.786 22.1634ZM23.8853 25.4601L22.9344 24.1306L15.3806 13.5618H18.633L24.731 22.0944L25.6778 23.4239L33.6033 34.5143H30.351L23.8853 25.4601Z"
                    fill="white"
                  />
                </svg>
                <p className="text-sm leading-4 font-medium text-center truncate">
                  <span className="line-through">Twitter</span> X
                </p>
              </Link>
              <Link
                to={"https://t.me/HoldstationW_EN"}
                target="_blank"
                className="flex flex-col gap-2 justify-center items-center"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="49"
                  height="48"
                  viewBox="0 0 49 48"
                  fill="none"
                  className="mx-2"
                >
                  <title>Telegram</title>
                  <rect
                    x="0.5"
                    width="48"
                    height="48"
                    rx="12"
                    fill="url(#paint0_linear_183_997)"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.3637 23.7467C18.3602 20.6984 23.0256 18.6888 25.36 17.7179C32.025 14.9456 33.41 14.4641 34.3127 14.4482C34.5112 14.4447 34.9551 14.4939 35.2427 14.7272C35.4855 14.9242 35.5523 15.1904 35.5842 15.3772C35.6162 15.564 35.656 15.9895 35.6244 16.322C35.2632 20.1169 33.7004 29.3263 32.9053 33.5767C32.5689 35.3753 31.9064 35.9783 31.2651 36.0373C29.8714 36.1656 28.8131 35.1162 27.4632 34.2314C25.3509 32.8467 24.1575 31.9848 22.1072 30.6336C19.7376 29.0721 21.2737 28.2139 22.6241 26.8113C22.9775 26.4442 29.1183 20.8587 29.2371 20.352C29.252 20.2887 29.2658 20.0524 29.1255 19.9277C28.9851 19.803 28.778 19.8456 28.6286 19.8796C28.4167 19.9276 25.0423 22.158 18.5052 26.5707C17.5474 27.2284 16.6798 27.5489 15.9025 27.5321C15.0456 27.5136 13.3972 27.0476 12.1718 26.6492C10.6688 26.1607 9.47426 25.9024 9.57827 25.0726C9.63245 24.6405 10.2276 24.1985 11.3637 23.7467Z"
                    fill="white"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_183_997"
                      x1="24.5"
                      y1="0"
                      x2="24.5"
                      y2="48"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#2AABEE" />
                      <stop offset="1" stopColor="#229ED9" />
                    </linearGradient>
                  </defs>
                </svg>
                <p className="text-sm leading-4 font-medium text-center truncate">
                  Telegram
                </p>
              </Link>
            </div>
          </div>
        </WrapperFinder>
      </div>
    </Scale>
  );
}
